import { NavigationItem } from "./navigationItem";
import { LocationInfo } from "./locationInfo";
import { SocialLink } from './socialLink';
import { AssociationLogo } from './associationLogo';
import { PageSettings } from "./pageSettings";
import { PortableInfo } from "./portableInfo";

export class Client {
  freshpingId: number;
  country = 'usa';
  pushRateThreshold: number;
  propertySoftware: string;
  storageCommanderLocId: string | null;
  primaryHex: string;
  accentHex: string;
  numUnitsToShowUnitNumberLeft: number;
  reCaptchaSiteKey: string;
  $key: string;
  logoUrl: string;
  code: string;
  name: string;
  tagLine: string;
  locations: Array<LocationInfo>;
  siteUrl: string;
  squareLogoUrl: string;
  faviconUrl: string;
  useFavicon: boolean;
  fontUrl: string;
  fontUrls: string[] = [];
  cacheExpireSeconds: number;
  defaultLocationKey: string;
  analyticsId: string;
  analyticsViewId: string;
  rentReserveButtonClick: boolean;
  rentReserveButtonClickTrackingCode?: string;
  rentReserveSuccessPageTrack: boolean;
  rentReserveSuccessPageTrackingCode?: string;
  contactFormSubmitTrack: boolean;
  contactFormSubmitTrackingCode?: string;
  instantQuoteSubmitTrack: boolean;
  instantQuoteSubmitTrackingCode?: string;
  abbreviateStates: boolean;
  socialLinks: SocialLink[];
  associationLogos: AssociationLogo[];
  showSocialLinks: boolean;
  suppressGetUnits: boolean;
  useGeolocation: boolean;
  useSms: boolean;
  description: string;
  pages: PageSettings;
  changeLocationOrder: boolean;
  changeHomePageOrder: boolean;
  changeLocationHomePageOrder: boolean;
  homepageComponentsOrder: Array<any> = [];
  locationHomepageComponentsOrder: Array<any> = [];
  locationsOrder: string[];
  locationsOrderType = 'ungrouped';
  locationsGroups: any[];
  locationsGroupsLocationKeys: any[];
  enableCustomPages: boolean;
  enableBlog: boolean;
  reviewSettings: any;
  reviews: any;
  dateLastDeployed: any;
  socialMediaFooterBlurb: string;
  fbEmail: string;
  fbPassword: string;
  components: any;
  locationNavLocation: string;
  infoNavLocation: string;
  infoBarStyle: string;
  locationBarStyle: string;
  mainNavBar: string;
  locationSlideout: string;
  homePageButtonComponent: string;
  homePageFeaturesComponent: string;
  homePageMainIconsComponent: string;
  homePageFindUsComponent: string;
  aboutUsHero: string;
  customPageHero: string;
  aboutUsMainSection: string;
  sizeGuideHero: string;
  sizeGuideMainSection: string;
  contactForm: string;
  contactHeader: string;
  footer: string;
  associations: string;
  switchLocationComponent: string;
  portalLoginComponent: string;
  viewAllUnitsComponent: string;
  viewAllUnitsComponentHeaderType: string;
  comingSoonComponent: string;
  htmlRowComponent: string;
  portableQuoteBarComponent: string;
  separatorBarComponent: string;
  locationSeparatorBarComponent: string;
  locationBannerComponent: string;
  facilityInfoBannerComponent: string;
  slideshowRowComponent: string;
  howToRowComponent: string;
  uhaulDealerBannerComponent: string;
  locationsNearYouBannerComponent: string;
  homePageFeaturesComponentLocation: string;
  headerType: string;
  storeLocatorHeader: string;
  storeLocatorComponent: string;
  googleMapComponent: string;
  googleMapComponentLocation: string;
  generalInfoHeader: string;
  generalInfoMainSection: string;
  faqsHeader: string;
  faqsMainSection: string;
  viewAllReviewsHeader: string;
  storageTipsHeader: string;
  storageTipsBody: string;
  storageCalculatorBody: string;
  storageCalculatorHeader: string;
  locationHomeViewAllUnitsComponent: string;
  customJs: string;
  customBuildtimeJsBody: string;
  customBuildtimeJsHead: string;

  hubspotCompanyId: number;

  autoPayTerms: string;

  showAnnouncement: boolean;
  announcementText: string;
  announcementBgColor: string;
  announcementColor: string;
  announcementFontSize: string;

  demoLinkUrl: string;
  demoLinkShortUrl: string;

  clearOutSelectedLocationWhenNavigatingHome?: boolean;
  goToLocationHomeOnLogoClick?: boolean;

  useCorporateHomeLink: boolean;
  useCorporateContactInfo: boolean;
  useCorporateContactPage: boolean;
  corporateAddress?: string;
  corporateAddress2?: string;
  corporatePhone?: string;
  corporateEmail?: string;

  showLocationNameInsteadOfClientName?: boolean;

  portableQuoteBarData = {
    title: 'Instant Quote',
    background: 'rgba(255, 255, 255, 1)',
    color: '#607D8B',
    titleFontSize: '2.4em',
  };

  xpsInfo?: {
    active?: boolean;
    js?: string;
    spanId?: string;
    onclick?: string;
  };

  facebookPixelInfo?: {
    productCatalogId?: boolean;
    active?: boolean;
    id?: string;
  };

  podiumInfo?: {
    active?: boolean;
    apiToken?: string;
  };

  separatorBarData = {
    title: '',
    text: '',
    background: 'rgba(255, 255, 255, 1)',
    color: '',
    titleFontSize: '2.4em',
    textFontSize: '20px',
    hideBottomTextOnMobile: false
  };

  locationSeparatorBarData = {
    height: '350px',
    background: 'rgba(255, 255, 255, 1)',
    color: '',
    titleMarginTop: '20px',
    textMarginTop: '20px',
    titleFontSize: '2.4em',
    textFontSize: '20px',
  };

  htmlRowData = {};

  //   { name: 'height', type: 'string', size: 'small', text: 'Height' },
  // { name: 'background', type: 'color', size: 'small', text: 'Background' },
  // { name: 'color', type: 'color', size: 'small', text: 'Color' },
  // { name: 'titleColor', type: 'color', size: 'small', text: 'Title Color' },
  locationBannerData = {
    height: 'auto',
    padding: '25px',
    background: '#FFFFFF',
    showSeparator: true,
    separatorColor: null,
    lineColor: null,
    color: null,
    titleColor: null,
    locationNameColor: null,
    placement: 'aboveSeparator',
    showPictures: true,
    locationBoxColor: "#fff",
    title: 'Our Locations',
    subtitle: '',
    linkToUnitsPage: false,
    showGroupBlurbs: false
  };

  facilityInfoBannerData = {
    height: 'auto',
    padding: '25px',
    background: '#FFFFFF',
    showAccent: 'true',
    showCta: 'true',
    color: null,
    titleColor: null,
    lineColor: null,
    layout: 'imageRight',
    breakpoint: 'cell',
    placement: 'aboveSeparator',
    onlyShowOnCorporateHome: true,
    fontSize: '1em',
    showCard: false,
    titleFontSize: '2em',
    largerImage: false
  };

  slideshowRowData = {
    titleText: '',
    titleSize: '',
    titleColor: '',
    autoplaySlides: true,
    fullPageWidth: false,
    showSideArticle: false,
    sideArticleOnLeft: false,
    articleCard: true,
    slideHeight: '350px',
    backgroundColor: '',
    slideBackgroundSize: 'cover',
    articleCardBGColor: '',
    articleTextColor: ''
  };

  howToRowData = {
    background: '',
    breakSmall: false,
    cardBackground: '',
    cardTextColor: "",
    cardTitleFontSize: '',
    cardFontSize: '',
  };

  uhaulDealerBannerData = {
    height: 'auto',
    padding: '25px',
    background: '#FFFFFF',
    placement: 'aboveFooter',
    uhaulLink: null
  };
  viewAllUnitsComponentHeaderTypeData = {
    sidebar: 'show',
    background: 'linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url("https://cdn.storagepug.com/hubfs/Client%20Website%20Images/All/AdobeStock_273706852.jpeg") no-repeat',
    height: '',
  };

  comingSoonComponentData = {
    backgroundColor: '#F2F4F7',
  }

  viewAllUnitsComponentData = {
    border: "2px solid #6689FF",
    catButtonsBackground: "",
    catButtonsColor: "",
    rentButtonBackground: "",
    rentButtonColor: "",
    reserveButtonBackground: "",
    reserveButtonColor: "",
    viewUnitsChipBackground: "",
    viewUnitsChipColor: "",
    discountColor: "",
    rentUnitFontSize: "",
    reserveUnitFontSize: "",
    ctaText: "Reserve Your Unit Today!",
    spaceInsteadOfUnit: false,
    lazyLoadUnits: false,
    small: false,
    initialSortSize: "",
    titleText: "Available Storage Units",
    breakPoint: "sm",
    titleFontSize: '',
    titleMargin: '30px 0',
    titleTextAlign: 'center',
    titleColor: '',
    smallSettingsFilterTitleFullText: false,
    smallSettingsShowFilterIcons: false,
    wrapperBg: '',
    wrapperPaddingBottom: '50px',
    filterChipColor: '',
    filterChipBg: '',
    filterChipThreshold: 5,
    filterBackground: '',
    filterIconFontSize: '',
    filterShowIcons: true,
    amenitiesIconWidth: '50px',
    amenitiesType: 'icon',
    amenitiesIconMargin: '5px 5px 0 0',
    checkoutSidebarColor: '',
    priceShowBorder: false,
    priceFontSize: '',
    priceOldRateColor: '',
    priceOldRateFontSize: '',
    priceDiscountFontSize: ''
  };

  infoBarStyleData = {
    logoCenteredPhoneIcon: 'https://firebasestorage.googleapis.com/v0/b/storpug-main.appspot.com/o/icons%2Fphone.png?alt=media&token=349e2fa5-cb77-4fac-9534-ffa678300d81',
    logoCenteredMapIcon: 'https://firebasestorage.googleapis.com/v0/b/storpug-main.appspot.com/o/icons%2Fmap-icon.png?alt=media&token=2efd5ebd-8d13-4539-8e2c-719a98006986',
    logoHeight: '100px',
    mobileLogoHeight: '60px',
    marginTop: '25px',
    logoMarginTop: '0px',
    height: '32px',
    mobileHeight: '40px',
    iconHeight: '35px',
    iconWidth: '50px',
    background: 'rgba(255, 255, 255, 1)',
    color: '',
    hoverColor: '',
    showAllLocations: true,
    linkText: 'Login | Pay Bill',
    linkIcon: 'payment',
    linkRoute: '/customer-portal/login',
    fontSize: '',
    hideClientEmail: true,
  };

  homePageMainIconsComponentData = {
    background: "",
    boxBackground: "#fff",
    color: "",
    featureIconBackgroundColor: "",
    featureIconColor: "",
    showBoxShadow: true,
    showBoxes: true,
    showMaterialDesignShading: true,
    size: "55px",
    textFontSize: "",
    titleFontSize: "",
  };

  homePageButtonComponentData = {
    background: 'rgba(255, 255, 255, 1)',
    buttonBackground: '#FF9800',
    buttonColor: '#fff',
    height: '300px',
    buttonWidth: '80%',
    buttonFontSize: '2.5em',
    buttonPadding: '15px',
    ctaUrl: '',
    color: '#fff',
    title: 'Get Started',
    titleFontSize: '26px',
    textFontSize: '14px',
    hideContactUsButton: false,
    text: 'Rent your unit today. Rent your unit today. Rent your unit today. Rent your unit today.',
    leftButtonText: "Rent Your Unit",
    leftButtonLink: "units",
    rightButtonText: "Contact Us",
    rightButtonLink: "contact"
  };

  homePageFeaturesComponentData = {
    background: "",
    circleBackground: "",
    color: "",
    featureIconBackgroundColor: "",
    featureIconColor: "",
    fontSize: "",
    showCircles: false,
    showMaterialDesignShading: false,
    showTitle: true,
    size: "55px",
    title: "Facility Features",
    subtitle: "",
    uppercase: true,
    backColor: ""
  };

  homePageFindUsComponentData = {
    background: 'rgba(255, 255, 255, 0)',
    color: '',
    height: '145px',
    title: '',
    subtitle: ''
  };

  mainNavBarStyleData = {
    showMaterialDesignShading: true,
    mattStyle: false,
    showLogo: true,
    height: '70px',
    fontSize: '',
    color: '',
    hamburgerColor: '',
    payBillColor: '',
    payBillBackground: '',
    payBillBorder: '',
    logoHeight: '50px',
    payBillText: 'Login | Pay Bill',
    background: 'rgba(255, 255, 255, 1)',
    smHamburger: true,
    mdHamburger: false,
    activePayBillButton: false,
    showUserAccount: false
  };

  locationBarStyleData = {
    showMaterialDesignShading: true,
    showChangeLocationButton: false,
    height: '32px',
    background: 'rgba(255, 255, 255, 1)',
    color: '',
    fontSize: '',
    linkColor: '',
    highlightColor: '',
    selectedLocationColor: '',
  };

  sizeGuideHeroData = {
    useCard: false,
    cardBackground: '#FFF',
    cardBorderRadius: '10px',
    cardPadding: '34px',
    height: '200px',
    background: 'linear-gradient(rgba(0,0,0,.33),rgba(0,0,0,.33)), url() center no-repeat',
    backgroundSize: 'cover',
    fontWeight: '',
    color: '#fff',
    title: ''
  };

  sizeGuideMainSectionData = {
    color: '#000',
    sideButtonColor: '#000',
    sideButtonSelectedColor: '#fff',
    sideButtonSelectedBackgroundColor: '#ccc',
    fontSize: '20px',
  };

  aboutUsHeroData = {
    useCard: false,
    cardBackground: '#FFF',
    cardBorderRadius: '10px',
    cardPadding: '34px',
    height: '200px',
    background: 'linear-gradient(rgba(0,0,0,.33),rgba(0,0,0,.33)), url() center no-repeat',
    backgroundSize: 'cover',
    fontWeight: '',
    color: '#fff',
    title: '',
    subtitle: ''
  };

  aboutUsMainSectionData = {
    useSlider: false
  };

  customPageHeroData = {
    useCard: false,
    cardBackground: '#FFF',
    cardBorderRadius: '10px',
    cardPadding: '34px',
    height: '200px',
    background: 'linear-gradient(rgba(0,0,0,.33),rgba(0,0,0,.33)), url() center no-repeat',
    backgroundSize: 'cover',
    fontWeight: '',
    color: '#fff'
  };

  viewAllReviewsHeaderData = {
    useCard: false,
    cardBackground: '#FFF',
    cardBorderRadius: '10px',
    cardPadding: '34px',
    height: '200px',
    background: 'linear-gradient(rgba(0,0,0,.33),rgba(0,0,0,.33)), url() center no-repeat',
    backgroundSize: 'cover',
    fontWeight: '700',
    color: '#FFF'
  };

  storeLocatorHeaderData = {
    useCard: false,
    cardBackground: '#FFF',
    cardBorderRadius: '10px',
    cardPadding: '34px',
    height: '200px',
    background: 'linear-gradient(rgba(0,0,0,.33),rgba(0,0,0,.33)), url() center no-repeat',
    backgroundSize: 'cover',
    fontWeight: '700',
    color: '#fff',
    title: ''
  };

  storageCalculatorHeaderData = {
    useCard: false,
    cardBackground: '#FFF',
    cardBorderRadius: '10px',
    cardPadding: '34px',
    height: '200px',
    background: 'linear-gradient(rgba(0,0,0,.33),rgba(0,0,0,.33)), url() center no-repeat',
    backgroundSize: 'cover',
    fontWeight: '700',
    color: '#fff',
    title: '',
    subtitle: ''
  };

  storageCalculatorBodyData = {};

  storageTipsHeaderData = {
    useCard: false,
    cardBackground: '#FFF',
    cardBorderRadius: '10px',
    cardPadding: '34px',
    height: '300px',
    background: 'linear-gradient(rgba(0,0,0,.33),rgba(0,0,0,.33)), url() center no-repeat',
    backgroundSize: 'cover',
    fontWeight: '700',
    color: '#fff',
    title: '',
    subtitle: '',
  };

  storageTipsBodyData = {
    showTipsBlurb: false,
    blurbTipsPlacement: 'left'
  };

  locationSlideoutData = {
    titleBackground: '#3D73B9',
    titleColor: '#fff',
    titleFontSize: '20px',
    locationTitleColor: '#3D73B9',
    locationTitleSize: '20px',
    locationFontColor: '#000',
    locationFontSize: '14dpx',
    locationLinkColor: '#3D73B9',
    heightFromTop: '250px',
    innerHeightFromTop: '250px',
    innerHeight: '330px',
    titleHeight: '170px',
    titleBorderRadius: '0 5px 5px 0',
    innerWidth: '500px',
    border: '1px solid #3D73B9',
    titleText: 'Location Info',
    leftButtonText: 'Corporate Home',
    rightButtonText: 'Switch Location',
    locationButtonBackground: '#3D73B9',
    isRightSide: false,
    useMapComponentInstead: false,
  };

  contactHeaderData = {
    useCard: false,
    cardBackground: '#FFF',
    cardBorderRadius: '10px',
    cardPadding: '34px',
    height: '200px',
    background: 'linear-gradient(rgba(0,0,0,.33),rgba(0,0,0,.33)), url() center no-repeat',
    backgroundSize: 'cover',
    fontWeight: '700',
    color: '#fff',
    title: ''
  };

  generalInfoHeaderData = {
    useCard: false,
    cardBackground: '#FFF',
    cardBorderRadius: '10px',
    cardPadding: '34px',
    height: '200px',
    background: 'linear-gradient(rgba(0,0,0,.33),rgba(0,0,0,.33)), url() center no-repeat',
    backgroundSize: 'cover',
    fontWeight: '700',
    color: '#fff',
    title: ''
  };

  faqsHeaderData = {
    useCard: false,
    cardBackground: '#FFF',
    cardBorderRadius: '10px',
    cardPadding: '34px',
    height: '200px',
    background: 'linear-gradient(rgba(0,0,0,.33),rgba(0,0,0,.33)), url() center no-repeat',
    backgroundSize: 'cover',
    fontWeight: '700',
    color: '#fff',
    title: ''
  };

  faqsMainSectionData = {
    fontSize: '',
    titleFontSize: '',
    titleColor: '',
    selectedTitleColor: '',
    selectedTitleBackgroundColor: '',
    showBlurb: true,
    blurbPlacement: 'left',
  };

  generalInfoMainSectionData = {};

  portalLoginData = {
    simpleLogoUrl: '',
    backgroundImageUrl: 'url(https://firebasestorage.googleapis.com/v0/b/fir-space-toggle.appspot.com/o/spaceToggle.jpg?alt=media&token=57103f13-c909-4687-ae80-dc6aac3378e8)',
    formBackground: 'linear-gradient(rgba(33,33,33,.65),rgba(33,33,33,.65))',
    formColor: '#dddddd',
    existingCustomersColor: '#636973',
    existingCustomersButtonColor: '#FF9800',
    locationColor: '#636973',
    logoWidth: '130px',
    hideLogo: false,
    showChangeLocationButton: true,
  };

  contactFormData = {
    phoneAddressFontSize: '',
    showLocationName: false,
    contactCtaBlurb: 'Thanks for taking the time to reach out to us. We look forward to helping in any way we can!',
    subtitleFontSize: '',
    showPhoneNumber: true,
    showUnitNumber: false,
    windowBorderRadius: '10px',
    windowPlacement: 'right'
  };

  sizeGuideRentReserveButtonData = {
    padding: '9px',
    fontSize: 'large',
    minWidth: '120px'
  };

  switchLocationComponentData = {
    imageHeight: '135px',
    titleFontSize: '',
    titleFontWeight: '',
    titleFontColor: '',
    phoneColor: '',
    phoneSize: '',
    buttonFontSize: '',
    buttonPadding: '',
    buttonColor: '',
    buttonWidth: '100%',
    buttonBackground: '',
    buttonMarginTop: '15%',
    background: 'rgba(255, 255, 255, 1)',
    isClickableStates: true,
    noneSelectedImage: 'https://cdn.storagepug.com/hubfs/Blog%20Headers%20StoragePug/no-drafts@4x.png',
    noneSelectedTitle: 'Rent a unit online with ease.',
    noneSelectedText: 'Get started by selecting your state'
  };

  footerData = {
    background: '#33475B',
    color: '#DDD',
    trademarkBackground: '#2A3B4B',
    trademarkColor: '#636973',
    height: '200px',
    trademarkHeight: '50px',
    phoneFontSize: '20px',
    titleFontSize: '20px',
    linkColor: '#DDD',
    showDropdownLinks: true,
    showBottomText: false,
    showFacilityNameAndLocation: false,
    bottomText: '',
    subheading: '',
    altLogoUrl: '',
  };

  associationsData = {
    background: '#333333',
    height: '',
    logoMaxHeight: '',
    logoMaxWidth: '200px',
    placement: 'aboveFooter',
    title: '',
    subtitle: ''
  };

  tabBoxData = {
    width: '400px',
    color: '#636973',
    mobileColor: '#636973',
    tabLabelColor: '#636973',
    mobileTabLabelColor: '#636973',
    titleSize: '1.37em',
    titleColor: '#636973',
    background: 'hsla(0,0%,100%,.8)',
    borderRadius: '10px',
    left: '5%',
    top: '10%',
    minHeight: '431px',
    buttonWidth: '90%',
    buttonFontSize: '1.6em',
    padding: '0px 25px 25px 25px',
    buttonPadding: '15px',
    buttonMarginTop: '15px',
    buttonBackground: '#6689FF',
    buttonColor: '#fff',
    phoneLinkColor: '#6689FF',
    taglineFontStyle: '',
    showLocationName: false,
    showEmail: false,
    corporateHeroHeight: '525px',
    locationHeroHeight: '525px',
    locationShowImagesOnV2: false
  };

  locationHomeViewAllUnitsData = {
    lazyLoadUnits: false,
    small: false,
    showFacilityName: false,
    initialSortSize: "",
    showTitleShading: false,
    titleText: "Available Storage Units",
    breakPoint: "sm",
    titleFontSize: '',
    titleMargin: '30px 0',
    titleTextAlign: 'center',
    titleColor: '',
    smallSettingsFilterTitleFullText: false,
    smallSettingsShowFilterIcons: false,
    wrapperBg: '#fff',
    wrapperPaddingBottom: '50px',
    filterChipColor: '#fff',
    filterChipBg: 'rgb(244, 189, 40)',
    filterChipThreshold: -1,
    filterBackground: '#efefef',
    filterIconFontSize: '',
    filterShowIcons: true,
    amenitiesIconWidth: '40px',
    amenitiesType: 'icon',
    amenitiesIconMargin: '5px 5px 0 0',
    priceShowBorder: false,
    priceFontSize: '',
    priceOldRateColor: '#94949B',
    priceOldRateFontSize: '',
    priceDiscountFontSize: '',
    showLocationInfoMapCard: false
  }

  locationTabBoxData = {
    width: '400px',
    color: '#636973',
    mobileColor: '#636973',
    tabLabelColor: '#636973',
    mobileTabLabelColor: '#636973',
    titleSize: '1.37em',
    titleColor: '#636973',
    background: 'hsla(0,0%,100%,.8)',
    borderRadius: '10px',
    left: '5%',
    top: '10%',
    minHeight: '431px',
    buttonWidth: '90%',
    buttonFontSize: '1.6em',
    padding: '0px 25px 25px 25px',
    buttonPadding: '15px',
    buttonMarginTop: '15px',
    buttonBackground: '#6689FF',
    buttonColor: '#fff',
    phoneLinkColor: '#6689FF',
    taglineFontStyle: '',
    showLocationName: false,
    showEmail: false,
    corporateHeroHeight: '525px',
    locationHeroHeight: '525px',
    locationShowImagesOnV2: false
  };

  bigTitleData = {
    titleSize: '4em',
    titleWeight: '600',
    titleColor: '#636973',
    titleShadow: '0px 4px 6px #000000',
    titleMargin: '20% auto 5px auto',
    background: 'transparent',
    minHeight: '431px',
    buttonWidth: '20%',
    buttonMaxWidth: '215px',
    buttonFontSize: '1.6em',
    padding: '0px 25px 25px 25px',
    buttonPadding: '15px',
    buttonMargin: '15px',
    buttonBackground: '#6689FF',
    buttonColor: '#fff',
    phoneLinkColor: '#6689FF'
  };

  portalNavbarData = {
    height: '45px',
    fontSize: '20px',
    padding: '8px 12px 8px 12px',
    mattStyle: false
  };

  googleMapData = {
    mapHeight: '600px',
    showLocationName: false,
    hideEmail: false,
    zoomToLocation: true,
    useSnazzyWindows: true,
    showCloseButton: true,
    windowPlacement: 'right',
    borderRadius: '10px'
  };

  locationsNearYouBannerData = {
    background: '#37474F',
    cardColor: '#37474F',
    closestStoreRibbonColor: '#37474F',
    closestStoreRibbonBackgroundColor: '#FFF',
    color: '#E0E0E0',
    linkColor: '#E0E0E0',
    hideQuoteForm: false
  };

  storeLocatorData = {
    showCloseButton: true,
    showSearchBarOnHomePage: false,
    autofill: true,
    panelMode: false,
    windowPlacement: 'right',
    borderRadius: '10px',
    closestStoreRibbonColor: '#fff',
    closestStoreRibbonBackgroundColor: 'green',
    selectedStoreRibbonColor: '#fff',
    selectedStoreRibbonBackgroundColor: 'blue',
  };
  // showMainInfo: boolean;
  // mainEmail: string;
  // mainAddress: string;
  // mainAddress2: string;
  // mainPhone: string;

  // showMainHours: boolean;
  // hours: Array<Hour>;
  // gateHours: Array<Hour>;

  navigation: Array<NavigationItem>;

  portableMode: boolean;
  portableInfo: PortableInfo;

  constructor() {
    this.locations = [];
    this.navigation = [];
    this.footer = 'original';
    this.locationHomeViewAllUnitsComponent = 'original';
    this.htmlRowComponent = 'original';
    this.portableQuoteBarComponent = 'original';
    this.separatorBarComponent = 'original';
    this.locationSeparatorBarComponent = 'original';
    this.locationBannerComponent = 'none';
    this.facilityInfoBannerComponent = 'none';
    this.slideshowRowComponent = 'none';
    this.howToRowComponent = 'original';
    this.uhaulDealerBannerComponent = 'none';
    this.portalLoginComponent = 'simple';
    this.viewAllUnitsComponent = 'modern';
    this.comingSoonComponent = 'original';
    this.switchLocationComponent = 'original';
    this.aboutUsHero = 'original';
    this.contactForm = 'floatOverMap';
    this.sizeGuideMainSection = 'version2';
    this.sizeGuideHero = 'original';
    this.headerType = 'video';
    this.aboutUsMainSection = 'original';
    this.homePageFeaturesComponent = 'svg';
    this.homePageFeaturesComponentLocation = 'belowCTA';
    this.homePageMainIconsComponent = 'v3';
    this.homePageButtonComponent = 'original';
    this.homePageFindUsComponent = 'original';
    this.locationNavLocation = 'bottom';
    this.infoBarStyle = 'original';
    this.locationBarStyle = 'original';
    this.infoNavLocation = 'top';
    this.mainNavBar = 'original';
    this.cacheExpireSeconds = 1;
    this.analyticsId = '';
    this.rentReserveButtonClick = false;
    this.rentReserveSuccessPageTrack = false;
    this.pushRateThreshold = 3;
    this.numUnitsToShowUnitNumberLeft = 3;
    this.demoLinkUrl = 'https://';
    this.showAnnouncement = false;
    this.announcementText = '';
    this.announcementBgColor = '#000';
    this.announcementColor = '#FFF';
    this.announcementFontSize = '14px';
    this.socialLinks = [];
    this.showSocialLinks = false;
    this.suppressGetUnits = false;
    this.storeLocatorComponent = 'none';
    this.googleMapComponent = 'original';
    this.useGeolocation = false;
    this.useSms = false;
    this.associations = 'none';
    this.associationLogos = [];
    this.description = '';
    this.googleMapComponentLocation = 'aboveFooter';
    this.useCorporateHomeLink = false;
    this.useCorporateContactInfo = false;
    this.useCorporateContactPage = false;
    this.generalInfoHeader = 'none';
    this.generalInfoMainSection = 'none';
    this.faqsHeader = 'none';
    this.contactHeader = 'none';
    this.faqsMainSection = 'none';
    this.viewAllReviewsHeader = 'none';
    this.storageTipsHeader = 'none';
    this.storageTipsBody = 'none';
    this.storeLocatorHeader = 'none';
    this.storageCalculatorHeader = 'none';
    this.storageCalculatorBody = 'none';
    this.changeLocationOrder = false;
    this.changeHomePageOrder = false;
    this.locationsOrder = [];
    this.enableCustomPages = false;
    this.enableBlog = false;
    this.portableMode = false;
    this.portableInfo = new PortableInfo();
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/client.ts